module.exports = __webpack_public_path__ + "static/img/top-bg.b5fc168.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/top-bg.png
// module id = 0gUf
// module chunks = 7